module.exports = __webpack_public_path__ + "static/media/circle-rush.191d06ff.jpg";